import { Reducer } from 'redux';
import { ACTION } from './action-types';
import * as actions from './action-types';
import { FiltersInstanceState, FiltersState } from '../../components/filters/types';
import { reducer as simpleFormReducer, INITIAL_SIMPLEFORM_STATE } from 'app/infrastructure/simple-form/reducers';
import { STATE } from 'app/constants';
import { FilterOptionType } from 'app/area/filters/types';

export const INITIAL_STATE: FiltersState = {
  instances: {}
};

export const INITIAL_INSTANCE_STATE: FiltersInstanceState = {
  currentList: [],
  filterDomains: [],
  advancedSearchFields: [],
  advancedSearchTypes: [],
  ...INITIAL_SIMPLEFORM_STATE
};

const instanceReducers: { [indexer: string]: Reducer<FiltersInstanceState> } = {

  [ACTION.REQUEST_FILTER_DOMAINS]: (state: FiltersInstanceState, action: actions.RequestFilterDomains): FiltersInstanceState => {
    return {
      ...state
    };
  },

  [ACTION.RECEIVE_FILTER_DOMAINS]: (state: FiltersInstanceState, action: actions.ReceiveFilterDomains): FiltersInstanceState => {
    return {
      ...state,
      filterDomains: action.filters,
      reportData: action.report
    };
  },

  [ACTION.UPDATE_FILTERS]: (state: FiltersInstanceState, action: actions.UpdateFilters): FiltersInstanceState => {
    return {
      ...state,
      currentList: action.data
    };
  },

  [ACTION.RECEIVE_ADVANCED_SEARCH_TYPES]: 
  (state: FiltersInstanceState, action: actions.ReceiveAdvancedSearchTypes): FiltersInstanceState => {
    return {
      ...state,
      advancedSearchTypes: action.data
    };
  },

  [ACTION.RECEIVE_ADVANCED_SEARCH_OPTIONS]: 
  (state: FiltersInstanceState, action: actions.ReceiveAdvancedSearchOptions): FiltersInstanceState => {

    return {
      ...state,
      advancedSearchFields: action.options
    };
  },

  [ACTION.SET_FILTER_OPEN_STATE]: (state:FiltersInstanceState, action: actions.SetFilterOpenState): FiltersInstanceState => {
    return {
      ...state,
      currentList: state.currentList.map(f => f.id === action.id
        ? {
          ...f,
          isOpen: action.value
        } : f)
    };
  },

  [ACTION.SET_FILTER_OPTION]: (state: FiltersInstanceState, action: actions.SetFilterOption): FiltersInstanceState => {
    const filters = state.currentList;
    const selectedIndex = filters.findIndex(f => f.id === action.option.id);

    if (selectedIndex === -1) {
      return state;
    }

    const filtersBefore = filters.slice(0, selectedIndex);

    const modifiedFilter = {
      [FilterOptionType.MENU_OPTION]: {
        ...filters[selectedIndex],
        menuOptions: [
          ...filters[selectedIndex].menuOptions.filter(o => o.type !== action.option.type),
          action.option
        ]
      },
      [FilterOptionType.OPTION_TYPE]: {
        ...filters[selectedIndex],
        optionType: Number(action.option.type),
        subOptionTypes: [],
        initialValue: []
      },
      [FilterOptionType.SUB_OPTION_TYPE]: {
        ...filters[selectedIndex],
        subOptionTypes: action.option.subOptionTypes
      }
    };

    const filtersAfter = filters.slice(selectedIndex + 1);

    return {
      ...state,
      currentList: [
        ...filtersBefore,
        modifiedFilter[action.filterOptionType],
        ...filtersAfter
      ]
    };
  },

  [ACTION.CLEAR_FILTER_OPTIONS]: (state: FiltersInstanceState, action: actions.ClearFilterOptions): FiltersInstanceState => {
    return {
      ...state,
      currentList: state.currentList ? state.currentList.map(f => f.id === action.id
        ? {
          ...f,
          initialValue: [],
          menuOptions: [],
          optionType: undefined,
          subOptionTypes: []
        } : f) : []
    };
  },

  [ACTION.CLEAR_ALL_FILTER_OPTIONS]: (state: FiltersInstanceState, action: actions.ClearAllFilterOptions): FiltersInstanceState => {
    return {
      ...state,
      currentList: state.currentList ? state.currentList.map(f => ({
          ...f,
          initialValue: [],
          menuOptions: [],
          optionType: undefined,
          subOptionTypes: []
      })) : []
    };
  },

  [ACTION.CLEAR_ALL_FILTER_OPTIONS]: (state: FiltersInstanceState, action: actions.ClearAllFilterOptions): FiltersInstanceState => {
    return {
      ...state,
      currentList: state.currentList.map(f => ({
          ...f,
          initialValue: [],
          menuOptions: [],
          optionType: undefined,
          subOptionTypes: [],
          isOpen: false
      }))
    };
  },

  [ACTION.CLEAR_ALL]: (state: FiltersInstanceState, action: actions.ClearAll): FiltersInstanceState => {
    return {
      ...state,
      ...INITIAL_INSTANCE_STATE
    };
  }

};

const reducers: { [indexer: string]: Reducer<FiltersState> } = {
  [ACTION.ADD_INSTANCE]: (state: FiltersState, action: actions.AddInstance): FiltersState => {
    return {
      ...state,
      instances: {
        ...state.instances,
        [action.instanceKey]: {
          ...INITIAL_INSTANCE_STATE
        }
      }
    };
  },
  [ACTION.CLEAR_INSTANCE]: (state: FiltersState, action: actions.ClearInstance): FiltersState => {
    return {
      ...state,
      instances: Object.keys(state?.instances).reduce(
        (aggr, key) => {
          if (key !== action.instanceKey) {
            aggr[key] = state.instances[key];
          }
          return aggr;
        }, {}
      )
    };
  }
};

export const reducer: Reducer<FiltersState> = (state: FiltersState = INITIAL_STATE, action: any) => {
  if (instanceReducers[action.type] && action.instanceKey) {
    const r = instanceReducers[action.type];
    
    return {
      ...state,
      instances: {
        ...state.instances,
        [action.instanceKey]: {
          ...state.instances[action.instanceKey],
          ...(r && r(state.instances[action.instanceKey], action))
        }
      }
    };
  }
  else if (action?.path?.[0] === STATE.filters && action?.path?.[1] === 'instances' && action?.path?.[2]) {
    // Hacky way to get one simple form reducer per instance.. All simpleForm actions have a path property
    return {
      ...state,
      instances: {
        ...state.instances,
        [action.path[2]]: simpleFormReducer(action.path)(state.instances[action.path[2]] || {}, action)
      }
    };
  }
  else if (reducers[action.type]) {
    return reducers[action.type](state, action);
  }
  return state;
};
